import { useRecoilState } from 'recoil'
import PopupContainer from '@/components/PopupContainer'
import IconExclamation from '@/components/icons/IconExclamation'
import { showCancelAllConfirmationPopupState } from '@/recoil/OrderForm'
import fetcher from '@/api/fetcher'

import './CancelAllConfirmationPopup.css'

export default function CancelAllConfirmationPopup({ symbol }) {
  const [show, setShow] = useRecoilState(showCancelAllConfirmationPopupState)
  const closePopup = () => setShow(false)
  const onConfirmClick = () => {
    symbol ? fetcher.cancelAllOrder(symbol) : fetcher.cancelAllOrder()
    closePopup()
  }
  return (
    <PopupContainer
      className="cancel-all-confirmation-popup"
      show={show}
      hidePopupCallback={closePopup}
    >
      <IconExclamation className="popup-main-icon" />
      <div className="popup-title">Cancel All Orders</div>
      <div className="popup-description">
        Are you sure you want to cancel <br />
        <span className="text-highlight">All of your open orders?</span>
      </div>
      <div className="main-action-button noselect" onClick={onConfirmClick}>
        Yes, cancel all
      </div>
      <div className="text-button noselect" onClick={closePopup}>
        No, keep all
      </div>
    </PopupContainer>
  )
}
